<template>
    <svg
        :class="[direction]"
        width="19px"
        height="16px"
        viewBox="0 0 32 28"
    >
        <path :fill="color"  class="st0" d="M2,11.98h23.51l-8.07-8.08c-0.78-0.78-0.78-2.05,0-2.83c0.78-0.78,2.05-0.78,2.83,0l11.14,11.16 c0.42,0.42,0.59,0.97,0.57,1.52C31.99,13.83,32,13.9,32,13.98v0.03c0,0.91-0.61,1.67-1.44,1.91l-10,11c-0.78,0.78-2.05,0.78-2.83,0 c-0.78-0.78-0.78-2.05,0-2.83l7.34-8.08H2c-1.1,0-2-0.9-2-2v-0.03C0,12.88,0.9,11.98,2,11.98z"/>
    </svg>
</template>
<script>
export default {
    props: {
        direction: {
            type: String,
            default: 'right'
        },
        color: {
            type: String,
            default: '#636772'
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
svg
    transition: transform .625s
    will-change: transform
    &.left
        transform: rotate(180deg)
    &.down
        transform: rotate(90deg)
    &.top
        transform: rotate(-90deg)
</style>
